module.exports = __webpack_public_path__ + "img/ejemplo-contrato.d1104827.svg";